import { themeObject } from 'lib';

export const infoCardStyles = {
    card: {
        flexGrow: 1,
        border: '1px solid',
        borderColor: themeObject.palette.grayScale[200],
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: '5px',
        textTransform: 'none',
        zIndex: 1,
    },
    cardContent: {
        pb: 0,
    },
    title: {
        mb: 2,
        color: themeObject.palette.primary[700],
    },
    description: {
        color: themeObject.palette.grayScale[800],
    },
    cardActions: {
        display: 'flex',
        zIndex: 2,
    },
};
